import { useState, FC, ReactNode, useCallback, Fragment } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import NavBar from "./NavBar";
import Sidebar from "./Sidebar";
import { DRAWER_WIDTH } from "src/utils/constants";

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayout: FC<DashboardLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleCloseSidebar = useCallback((): void => {
    setIsSidebarOpen(false);
  }, []);

  const handleOpenSidebar = useCallback((): void => {
    setIsSidebarOpen(true);
  }, []);

  return (
    <Fragment>
      <Box
        display="flex"
        flex="1 1 auto"
        flexDirection="column"
        width="100%"
        pt={10}
        pb={2}
        sx={{ pl: { lg: DRAWER_WIDTH / 8 } }}
      >
        {children}
      </Box>
      <NavBar onOpenSidebar={handleOpenSidebar} />
      <Sidebar open={isSidebarOpen} onClose={handleCloseSidebar} />
    </Fragment>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
